import { Injectable } from '@angular/core';
import {
    TranslateTextCommand,
    TranslateTextCommandOutput,
    TranslateClient,
} from '@aws-sdk/client-translate';
import {
    BehaviorSubject,
    catchError,
    first,
    from,
    map,
    Observable,
    throwError,
} from 'rxjs';
import { environment as env } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { franc } from 'franc-min';
@Injectable({
    providedIn: 'root',
})
export class TranlationService {
    private translationDataSubject: BehaviorSubject<any> =
        new BehaviorSubject<any>(null);
    translationData$: Observable<any> =
        this.translationDataSubject.asObservable();

    // private translateClient: TranslateClient;
    constructor(private http: HttpClient) {
        // this.translateClient = new TranslateClient({
        //     credentials: {
        //         accessKeyId: env.credentails.accessKeyId,
        //         secretAccessKey: env.credentails.secretAccessKey,
        //     },
        //     region: env.credentails.region,
        // });
    }

    readJsonFile(filePath: string): Observable<any> {
        return this.http.get<any>(filePath);
    }

    putJsonFile(filePath: string, data: any): Observable<any> {
        return this.http.put<any>(filePath, data);
    }

    loadTranslationData(translationData: any): void {
        this.translationDataSubject.next(translationData);
    }
    detectLanguage(text: string): string {
        return franc(text);
    }

    // async translateText(
    //     text: string,
    //     targetLanguage: string,
    //     currentLang: string
    // ): Promise<string> {
    //     // Set the default source language to English if 'zu' is detected
    //     if (currentLang === 'zu') {
    //         currentLang = 'en';
    //     }

    //     // Ensure the target language is not the same as the source language
    //     if (currentLang === targetLanguage) {
    //         console.warn(
    //             'Source and target languages are the same. No translation needed.'
    //         );
    //         return text;
    //     }

    //     // Validate language codes
    //     if (!currentLang || !targetLanguage) {
    //         console.error('Invalid language codes provided');
    //         return text;
    //     }
    //     console.log(
    //         'CREDS',
    //         env.credentails.accessKeyId,
    //         env.credentails.secretAccessKey
    //     );

    //     // Define parameters for the translation request
    //     const params = {
    //         SourceLanguageCode: currentLang,
    //         TargetLanguageCode: targetLanguage,
    //         Text: text,
    //     };

    //     // TESTING
    //     // const params = {
    //     //     SourceLanguageCode: currentLang,
    //     //     TargetLanguageCode: targetLanguage,
    //     //     Text: 'Hello my name is John',
    //     // };

    //     // console.log('TEXT>>>>>>>>>>>>>>>>>>>>>>>', params.Text);
    //     try {
    //         console.log(
    //             `Attempting translation from ${params.SourceLanguageCode} to ${params.TargetLanguageCode}`
    //         );
    //         const translateCommand = new TranslateTextCommand(params);
    //         const data: TranslateTextCommandOutput =
    //             await this.translateClient.send(translateCommand);

    //         return data?.TranslatedText || '';
    //     } catch (error: any) {
    //         // Handle specific exceptions for unsupported language pairs
    //         if (error.name === 'UnsupportedLanguagePairException') {
    //             console.error(
    //                 `Translation not supported: ${currentLang} to ${targetLanguage}. Please check AWS Translate documentation for supported language pairs.`
    //             );
    //         } else {
    //             console.error('Translation error:', error.message);
    //         }
    //         // Return the original text or a fallback message
    //         return text;
    //     }
    // }

    async translateText(
        text: string,
        targetLanguage: string,
        currentLang: string
    ): Promise<string> {
        // Set the default source language to English if 'zu' is detected
        if (currentLang === 'zu') {
            currentLang = 'en';
        }

        // Ensure the target language is not the same as the source language
        if (currentLang === targetLanguage) {
            console.warn(
                'Source and target languages are the same. No translation needed.'
            );
            return text;
        }

        // Validate language codes
        if (!currentLang || !targetLanguage) {
            console.error('Invalid language codes provided');
            return text;
        }

        try {
            const response = await this.http
                .post<any>(env.firebaseCloudfunction.translateText, {
                    text,
                    targetLanguage,
                    currentLang,
                })
                .toPromise();
            return response.translatedText || '';
        } catch (error: any) {
            if (error.name === 'UnsupportedLanguagePairException') {
                console.error(
                    `Translation not supported: ${currentLang} to ${targetLanguage}. Please check AWS Translate documentation for supported language pairs.`
                );
            }
            console.error('Translation error', error.message);
            return text;
        }
    }

    // translateObject(obj: any, targetLanguage: string): Observable<any> {
    //     const translatedObj: any = {};
    //     const translatePromises: Promise<any>[] = [];

    //     // Translate each value in the object asynchronously
    //     for (const key in obj) {
    //         if (obj.hasOwnProperty(key)) {
    //             const value = obj[key];
    //             if (typeof value === 'object') {
    //                 // If the value is an object, recursively translate it
    //                 const translation$ = this.translateObject(
    //                     value,
    //                     targetLanguage
    //                 );
    //                 translatePromises.push(
    //                     translation$
    //                         .toPromise()
    //                         .then(
    //                             (translatedValue) =>
    //                                 (translatedObj[key] = translatedValue)
    //                         )
    //                 );
    //             } else {
    //                 // Otherwise, translate the value directly
    //                 const text = value;
    //                 if (text && text.trim().length > 0) {
    //                     const params = {
    //                         SourceLanguageCode: 'auto', // Automatically detect the source language
    //                         TargetLanguageCode: targetLanguage,
    //                         Text: text,
    //                     };
    //                     const translateCommand = new TranslateTextCommand(
    //                         params
    //                     );
    //                     const translatePromise =
    //                         this.translateClient.send(translateCommand);
    //                     translatePromises.push(translatePromise);
    //                     translatePromise.then(
    //                         (data: TranslateTextCommandOutput) => {
    //                             translatedObj[key] = data.TranslatedText;
    //                         }
    //                     );
    //                 } else {
    //                     // If text is empty or null, set the translated value to an empty string
    //                     translatedObj[key] = '';
    //                 }
    //             }
    //         }
    //     }

    //     // Combine all translation promises into a single observable
    //     return from(Promise.all(translatePromises)).pipe(
    //         map(() => translatedObj)
    //     );
    // }

    translateObject(
        obj: any,
        targetLanguage: string,
        sourceLanguage: string
    ): Observable<any> {
        const apiUrl = env.firebaseCloudfunction.translateObject;
        const body = { objectToTranslate: obj, targetLanguage, sourceLanguage };

        return this.http.post<any>(apiUrl, body).pipe(
            map((response) => response.translatedObject),
            catchError((error) => {
                console.error(
                    'Error translating object via Firebase function:',
                    error
                );
                return throwError(
                    () => new Error('Failed to translate object')
                );
            })
        );
    }
}
